module.exports = __webpack_public_path__ + "images/emoji/curly_loop.1ae067432a028353e5d1.png";